import { ReactElement } from 'react';
import PriceSchemesWizard from './PriceSchemesWizard';
import { IPriceSchemesModal } from './types';
import { Modal } from '@weareopenr/component-library';

import chefPlating from 'src/assets/images/chef-plating.png';

const PriceSchemesModal = ({ closeModal, open, priceSchemes, priceSchemeId }: IPriceSchemesModal): ReactElement => {
  return (
    <Modal open={open} closeModal={closeModal} image={chefPlating} imageAlt="Chef plating">
      <PriceSchemesWizard closeModal={closeModal} priceSchemeId={priceSchemeId} priceSchemes={priceSchemes} />
    </Modal>
  );
};

export default PriceSchemesModal;
